function readCookie(name) {
  if (!name) return null
  for (const cookie of document.cookie.split('; ')) {
    const [key, value] = cookie.split('=')
    if (key === name) return value
  }
  return null
}

class CookieUtility {
  /**
   * Read a single cookie value by name from `document.cookie`. Returns `null`
   * when the name is missing or no matching cookie exists, so callers can
   * branch on truthiness without treating an empty string as a hit.
   *
   * @param {string} name
   * @returns {string|null}
   */
  get(name) {
    return readCookie(name)
  }
}

export default new CookieUtility()
